import $ from "jquery";

const CONTAINER_SELECTOR = '[data-post-list-container]';
const MORE_LINK_SELECTOR = '[data-post-list-more-link]';
const ITEMS_SELECTOR = '[data-post-list-items]';

const ATTR_CURRENT_PAGE = 'data-post-list-pages-current';
const ATTR_TOTAL_PAGES = 'data-post-list-pages-total';
const ATTR_PAGINATOR_QUERY_STRING = 'data-post-list-query';

class PostListModule {
    constructor() {
        this.setupEvents();
    }

    setupEvents() {
        $('body').on(
            'click',
            MORE_LINK_SELECTOR,
            (ev) => {
                const $container = $(ev.currentTarget).closest(CONTAINER_SELECTOR);
                ev.preventDefault();
                if ($container.length) {
                    this.loadMore($container);
                }
            }
        )
    }

    async loadMore($container) {
        const $moreLink = $container.find(MORE_LINK_SELECTOR);
        const href = $moreLink.attr('href');

        if (!$moreLink.length || !href) {
            return;
        }

        const result = await fetch(href);
        const response = await result.text();
        const $html  = $($.parseHTML(response));

        const newItems = $html.find(ITEMS_SELECTOR).get(0);
        const $newMore = $html.find(MORE_LINK_SELECTOR);

        if ($newMore.length) {
            $moreLink.replaceWith($newMore);
        } else {
            $moreLink.remove();
        }

        if (newItems) {
            $(ITEMS_SELECTOR).append($(newItems).html());
        }
    }
}

export default PostListModule;


// WEBPACK FOOTER //
// ./assets/scripts/front/App/PostListModule.js